const CustomerScreenQuestionType = {
    BOOLEAN: 'BOOLEAN',
    OPTIONS: 'OPTIONS',
};

module.exports = CustomerScreenQuestionType;
